import { Col, PageHeader, Row, Select, Space } from "antd";
import LayoutCss from "layout/layout.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedClientIds,
  setGlobalRecruiters,
} from "redux/slices/globalSelectorSlice";
import {
  selectAvailableRecruiters,
  selectSelectedRecruiters,
} from "redux/slices/userSlice";
import "../../submitToBilling/submitToBilling.scss";
import { useMemo } from "react";
import { RecruiterCommissionApprovals } from "./recruiterCommissionApprovals/recruiterCommissionApprovals";
import { ExportCommissionApprovalsButton } from "./exportCommissionApprovalsButton/exportCommissionApprovalsButton";

export default function CommissionApprovalsPage() {
  const dispatch = useDispatch();

  const selectedClientIds = useSelector(selectSelectedClientIds);
  const availableRecruiters = useSelector(selectAvailableRecruiters);
  const selectedRecruiters = useSelector(selectSelectedRecruiters);

  const selectedRecruiterIds = useMemo(
    () => selectedRecruiters.map((i) => i.id),
    [selectedRecruiters],
  );
  const onRecruiterChange = (value) => {
    dispatch(setGlobalRecruiters(value));
  };

  return (
    <>
      <PageHeader
        ghost={false}
        title="Commission Approval"
        className={`${LayoutCss.appPageHeader} ${LayoutCss.pageHeader}`}
        extra={
          <>
            <ExportCommissionApprovalsButton
              recruiterIds={selectedRecruiterIds}
              clientIds={selectedClientIds}
            />
            <Select
              mode="multiple"
              showArrow
              maxTagCount={1}
              maxTagPlaceholder={(omittedValues) => {
                return (
                  <span className="custom-max-tag-count">
                    +{omittedValues.length}
                  </span>
                );
              }}
              allowClear
              showSearch
              optionFilterProp="label"
              placeholder="Select Recruiters"
              className="commision-select"
              value={selectedRecruiterIds}
              options={availableRecruiters.map((item) => ({
                value: item.id,
                label: item.name,
                disabled:
                  selectedRecruiters.length >= 10 &&
                  !selectedRecruiters.includes(item.id),
              }))}
              onChange={onRecruiterChange}
            />
          </>
        }
      />
      {selectedRecruiters.length > 0 ? (
        <Space direction="vertical" style={{ width: "100%" }}>
          {selectedRecruiters.map((item) => (
            <RecruiterCommissionApprovals
              key={item.id}
              recruiterId={item.id}
              recruiterName={item.name}
            />
          ))}
        </Space>
      ) : (
        <Row justify="center" align="middle" style={{ marginTop: "100px" }}>
          <Col>
            <div style={{ fontSize: "20px", textAlign: "center" }}>
              Please select recruiters to view commission approvals
            </div>
          </Col>
        </Row>
      )}
    </>
  );
}
